import React, {Component} from 'react';
import {injectIntl, IntlShape} from 'react-intl';
import PriceInput from '../PriceInput/PriceInput';

import './PriceInputs.less';
import {findDOMNode} from 'react-dom';

type OwnProps = {
    minPrice: number;
    maxPrice: number;
    maxAllowedPrice: number | null;
    isMax: boolean;
    locale: string;
    activeHandleIndex: number | null;
    onChange: (bounds: Array<number | null>) => any;
    currency: string;
};

type StateProps = {
    priceInputValuesAreValid: boolean;
};

type DispatchProps = {
    updatePriceInputValuesValidity: Function;
};

type Props = OwnProps &
    StateProps &
    DispatchProps & {
        intl: IntlShape;
    };

export class PriceInputs extends Component<Props> {
    getMinPriceLabel = (): string =>
        this.props.intl.formatMessage({
            id: 'min',
            defaultMessage: 'Min',
            description: 'label to identify the minimum price input',
        });

    getMaxPriceLabel = (): string =>
        this.props.intl.formatMessage({
            id: 'max',
            defaultMessage: 'Max',
            description: 'label to identify the maximum price input',
        });

    getMinPriceErrorMessage = (): string =>
        this.props.intl.formatMessage({
            id: 'priceInputMinMaxErrorMsg',
            defaultMessage: 'Minimum price must be smaller than maximum price',
            description:
                'label to explain min price value must be smaller than maximum price',
        });

    getMaxPriceErrorMessage = (): string =>
        this.props.intl.formatMessage({
            id: 'priceInputMaxMinErrorMsg',
            defaultMessage: 'Maximum price must be greater than minimum price',
            description:
                'label to explain max price value must be smaller than minimum price',
        });

    onChangeInputValue = (value: number, name: string) => {
        const bounds =
            name === 'minPrice'
                ? [value, this.props.maxPrice]
                : [this.props.minPrice, value];

        this.props.onChange(bounds);
    };

    onEnterPress = () => {
        const priceDropdown = document.querySelector('.PriceDropdown');

        if (priceDropdown) {
            const applyButton = priceDropdown.querySelector<HTMLElement>(
                '.DropdownPanel__apply-button'
            );

            const node = findDOMNode(this);

            if (
                priceDropdown.contains(node) &&
                applyButton &&
                applyButton.focus
            ) {
                applyButton.focus();
            }
        }
    };

    hasErrorMinPrice = (
        value: number,
        minAllowed?: number,
        maxAllowed?: number
    ): boolean => typeof maxAllowed === 'number' && value >= maxAllowed;

    hasErrorMaxPrice = (value: number, minAllowed?: number): boolean =>
        typeof minAllowed === 'number' && value <= minAllowed;

    handleCheckPriceInputHasError = (hasError: boolean) => {
        this.props.updatePriceInputValuesValidity(!hasError);
    };

    render() {
        const {
            minPrice,
            maxPrice,
            maxAllowedPrice,
            activeHandleIndex,
            isMax,
            priceInputValuesAreValid,
            currency,
            locale,
        } = this.props;

        return (
            <div className="PriceInputs">
                <PriceInput
                    id="PriceInput__MinValue"
                    name="minPrice"
                    isActive={activeHandleIndex === 0}
                    value={minPrice}
                    minAllowedPrice={0}
                    maxAllowedPrice={maxPrice}
                    label={this.getMinPriceLabel()}
                    onChange={this.onChangeInputValue}
                    onEnterPress={this.onEnterPress}
                    errorMsg={this.getMinPriceErrorMessage()}
                    hasErrorCallback={this.hasErrorMinPrice}
                    edapLabel="nightly_price_input_min_"
                    valueIsValid={priceInputValuesAreValid}
                    onCheckHasError={this.handleCheckPriceInputHasError}
                    currency={currency}
                    fullLocale={locale}
                />
                <PriceInput
                    id="PriceInput__MaxValue"
                    name="maxPrice"
                    isActive={activeHandleIndex === 1}
                    value={maxPrice}
                    minAllowedPrice={minPrice}
                    maxAllowedPrice={maxAllowedPrice}
                    label={this.getMaxPriceLabel()}
                    onChange={this.onChangeInputValue}
                    onEnterPress={this.onEnterPress}
                    errorMsg={this.getMaxPriceErrorMessage()}
                    hasErrorCallback={this.hasErrorMaxPrice}
                    valueIsInfinite={isMax}
                    edapLabel="nightly_price_input_max_"
                    valueIsValid={priceInputValuesAreValid}
                    onCheckHasError={this.handleCheckPriceInputHasError}
                    currency={currency}
                    fullLocale={locale}
                />
            </div>
        );
    }
}

export default injectIntl(PriceInputs);
